// Animation Background change Javascript
// Change background when section in in viewport
// tamaragency.com

function initBackgroundChange() {
  const sections = document.querySelectorAll("[data-background-change]");

  function checkSections() {
    const viewportTop = window.scrollY;
    const activationPoint = viewportTop + 100;

    sections.forEach((section) => {
      const sectionTop = section.offsetTop;
      const sectionBottom = sectionTop + section.offsetHeight;
      const inView =
        activationPoint >= sectionTop && viewportTop < sectionBottom;

      if (inView) {
        section.classList.add("in-view");
      } else {
        section.classList.remove("in-view");
      }
    });
  }

  window.addEventListener("scroll", checkSections);
  window.addEventListener("resize", checkSections);

  checkSections();
}

document.addEventListener("DOMContentLoaded", initBackgroundChange);

document.addEventListener("shopify:section:load", initBackgroundChange);
document.addEventListener("shopify:section:select", initBackgroundChange);